import React, {useContext, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/root/login.css';
import {User} from "../../model/root/User";
import {AuthContext} from '../../config/AuthContext';
import {CheckUser} from "../../dao/root/CheckUser";
import {Button, Form, Input} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";

const Login = () => {
    const [usuari, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [usuaripermisos, setUsuaripermisos] = useState<User>();
    const [routes, setRoutes] = useState([]);
    const {
        isLoggedIn, setLoggedIn, userId, setUserId, user, setUserPermissos, setPage, page
        , setToken, token, setUsuari
    } = useContext(AuthContext);

    const navigate = useNavigate();

    const handleUsernameChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setUsername(event.target.value);
    };

    const handlePasswordChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setPassword(event.target.value);
    };

    const check = async (usuari: string, password: string) => {
        const usuariP = await CheckUser(usuari, password, window.location.href);
        setUsuaripermisos(usuariP.json);
        const us: User = JSON.parse(usuariP.json);
        if (us != null && us.id !== null) {
            setLoggedIn(true);
            setUsuari(usuariP);
            setUserId(us.id + "");
            setUserPermissos(us);
            setToken(usuariP.token);
            setPage(window.location.href);
            console.log(window.location.pathname);
            if (!window.location.pathname.includes(`profile/${userId}`) && !window.location.pathname.includes(`pagament`))
                navigate('/home');
            else
                navigate(window.location.pathname);
        } else {
            setPage("");
            setToken("");
            alert("Usuari o password incorrecte");
        }
        setLoading(false);
    };

    const getLogo = () => {
        const href = window.location.href.toLowerCase();
        if (href.includes("artiesport")) return "/artiesport.png";
        if (href.includes("ambitescola")) return "/ambitescola.png";
        if (href.includes("mentsinquietes")) return "/inquiringminds.png";
        return "/logo512.png"; // imagen por defecto si quieres
    };

    const onFinish = (values: any) => {
        setLoading(true);
        check(values.username, values.password);
    };

    return (
        <React.Fragment>
            <br/>
            <div className="text-center mb-3">
                <img src={getLogo()} alt="logo" style={{ maxWidth: '200px' }} />
            </div>
            <Form
                name="normal_login"
                className="login-form login-container container-sm"
                initialValues={{remember: true}}
                onFinish={onFinish}
            >
                <Form.Item
                    name="username"
                    rules={[{required: true, message: 'Introdueix el teu nom d\'usuari'}]}
                >
                    <Input prefix={<UserOutlined className="site-form-item-icon"/>} placeholder="Username"/>
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[{required: true, message: 'Introdueix la teva contrasenya'}]}
                >
                    <Input
                        prefix={<LockOutlined className="site-form-item-icon"/>}
                        type="password"
                        placeholder="Password"
                    />
                </Form.Item>
                <Form.Item>
                    <Button className={"login-button"} type="primary" htmlType="submit" loading={loading} disabled={loading}>
                        Accedir
                    </Button>
                </Form.Item>
            </Form>
        </React.Fragment>

    );
};

export default Login;
